import { render, staticRenderFns } from "./DomainType.vue?vue&type=template&id=1ec9f28e"
import script from "./DomainType.vue?vue&type=script&lang=js"
export * from "./DomainType.vue?vue&type=script&lang=js"
import style0 from "./DomainType.vue?vue&type=style&index=0&id=1ec9f28e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports